export const SIGNAL_TYPES = Object.freeze({
    RETENTION: 'retention',
    ADOPTION: 'adoption',
    VISITOR_ADOPTION: 'visitorAdoption',
    VISITOR_ENGAGEMENT: 'visitorEngagement',
    VISITOR_FRUSTRATION: 'visitorFrustration',
    FEATURE_PAGE_ADOPTION: 'featurePageAdoption',
    VISITOR_RETENTION: 'visitorRetention',
    ACCOUNT_RETENTION: 'accountRetention',
});
